<ng-container *transloco="let t">
  @if (userBloc.liveSupport$ | async; as liveSupport) {
    <kui-a11y-live-announce
      [announcement]="
        (liveSupport?.title ? liveSupport.title + ', ' : '') + (finishedExpand ? t('opened') : t('closed'))
      "></kui-a11y-live-announce>
    <button
      class="header"
      (click)="toggleLiveSupport()"
      [attr.aria-label]="
        (liveSupport?.title ? liveSupport.title + ', ' : '') + (finishedExpand ? t('open') : t('closed'))
      ">
      <svg-icon class="icon-support" src="/assets/icons/live-support.svg"></svg-icon>
      <span class="title">{{ liveSupport?.title }}</span>
      <svg-icon class="icon-chevron" src="/assets/icons/chevron-right-nocircle.svg"></svg-icon>
    </button>
    <div class="contents" [attr.aria-hidden]="finishedExpand ? true : null">
      <kui-live-support-detail
        [liveSupport]="liveSupport"
        [productName]="environmentVariablesService.product | titlecase"
        (liveSupportLinkClicked)="liveSupportLinkClicked()"
        (liveSupportNumberClicked)="liveSupportNumberClicked()"></kui-live-support-detail>
    </div>
  }
</ng-container>
